<cc-details-view
  [event]="event"
  [assignedContacts]="assignedContacts"
  [recordUrl]="recordUrl">
</cc-details-view>
